import { render, staticRenderFns } from "./PropertyEdit.vue?vue&type=template&id=27cc2cd3&scoped=true&"
import script from "./PropertyEdit.vue?vue&type=script&lang=js&"
export * from "./PropertyEdit.vue?vue&type=script&lang=js&"
import style0 from "./PropertyEdit.vue?vue&type=style&index=0&id=27cc2cd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc2cd3",
  null
  
)

export default component.exports